import { render, staticRenderFns } from "./EventSettings.vue?vue&type=template&id=e003a90e&"
import script from "./EventSettings.vue?vue&type=script&lang=js&"
export * from "./EventSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports